import { Card, CardHeader } from "react-bootstrap";

const PanelCard = ({children, size, header}) => {

    if(size === "sm") return (
        <Card className="bg-dark text-light col-lg-5 col-xl-5 mb-5">
            {!!header && 
                <CardHeader className="fs-4 fw-bold px-4 py-3 bg-darker">
                    <span>{header}</span>
                </CardHeader>
            }
            {children}
        </Card>
    );

    return (
        <Card className="bg-dark text-light col-12 col-lg-10 mb-5">
            {!!header && 
                <CardHeader className="fs-4 fw-bold px-4 py-3 bg-darker">
                    <span>{header}</span>
                </CardHeader>
            }
            {children}
        </Card>
    );
}

export default PanelCard;